"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleDataProvider = exports.useLifecycleDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const LifecycleApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecycleApiService");
const LifecycleDataContext = React.createContext(undefined);
const useLifecycleDataContext = () => {
    const context = React.useContext(LifecycleDataContext);
    if (!context) {
        throw new Error("useLifecycleDataContext must be used within a LifecycleDataContext.Provider");
    }
    return context;
};
exports.useLifecycleDataContext = useLifecycleDataContext;
const LifecycleDataProvider = (props) => {
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const fetchLifecycle = (0, react_1.useCallback)(async (lastNDays, granularity) => {
        try {
            if (process.env.NODE_ENV === "development") {
                console.log("LifecycleDataProvider: fetchLifecycle", { lastNDays, projectApiKey });
            }
            const actorResult = await projectsContext.getActor(projectApiKey);
            if (!lodash_1.default.isNil(actorResult.error)) {
                console.warn("fetchLifecycle failed. no actor", actorResult.error);
                // noinspection ExceptionCaughtLocallyJS
                throw actorResult.error;
            }
            else {
                const projectLifecycleResultByChunks = (0, LifecycleApiService_1.getProjectLifecycleResultByChunks)(actorResult.actors, actorResult.accessToken, lastNDays, granularity);
                return await (0, DataProviderCommonTypes_1.getFeatureStateFromICPromise)(projectLifecycleResultByChunks);
            }
        }
        catch (e) {
            throw e;
        }
        // noinspection ExceptionCaughtLocallyJS
        throw new Error("unknown");
    }, [projectApiKey]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        fetchLifecycle,
    }), [
        fetchLifecycle,
    ], lodash_1.default.isEqual);
    return React.createElement(LifecycleDataContext.Provider, { value: value }, props.children);
};
exports.LifecycleDataProvider = LifecycleDataProvider;
